export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/jignjia-10a74b4eff37e74bb52b2428fb1819cf.png";